import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getPostStreamIdFromMediaSource } from '../helpers';
import { DEVIATIONS_PER_FETCH } from '../constants';
function* handleInitPostStream(action) {
    const mediaSource = action.payload;
    if (!mediaSource) {
        return;
    }
    const streamId = getPostStreamIdFromMediaSource(mediaSource);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    if (isStreamInitialized) {
        return;
    }
    const streamParams = {
        type: mediaSource
    };
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            itemsPerFetch: DEVIATIONS_PER_FETCH,
            streamParams
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitPostStream;
